export const VISIBLE_PERMISSION_TYPES = [
  "input",
  "output",
  "outputProfile",
  "inputProfile",
  "provider",
  "transcodingProfile",
  "transcodingOutput",
  "location",
];

export function supportsPermissionModalType(type) {
  return VISIBLE_PERMISSION_TYPES.includes(type);
}

export function cloneDeep(value) {
  return JSON.parse(JSON.stringify(value));
}

export function sortByName(items = []) {
  return [...items].sort((left, right) => {
    const leftName = String(left?.name || "").toLowerCase();
    const rightName = String(right?.name || "").toLowerCase();
    return leftName.localeCompare(rightName);
  });
}

export function buildClaimSelectionPath(claim) {
  const claims = String(claim || "").split(".");
  const claimLevel = claims.length;
  const isForUser = claims[0] === "usr";
  const isClientAdmin = claims[0] === "ca";

  if (isClientAdmin) return [`usr.${claims[2]}`, claim];
  if (claimLevel === 3 && isForUser) return [`${claims[0]}.${claims[2]}`, claim];
  if (claimLevel === 2 && isForUser) return [claim];
  return [`usr.${claims[2]}`, `usr.${claims[1]}.${claims[2]}`, claim];
}

export function buildClaimSelections(claims = []) {
  return (claims || []).map((claim) => buildClaimSelectionPath(claim));
}

export function serializeClaimSelections(selections = []) {
  return (selections || [])
    .map((selection) => (Array.isArray(selection) ? selection[selection.length - 1] : selection))
    .filter(Boolean);
}

export function buildPermissionSearchIndex(item, type) {
  const segments = [
    item?.name,
    item?.id,
    item?.description,
    item?.displayName,
    item?.status,
    item?.type,
    item?.outputType,
    type,
  ];

  if (type === "input") {
    segments.push(item?.streamFileBaseName, item?.url, item?.inputDownlinkConfigId, item?.location);
  }

  if (type === "output") {
    segments.push(
      item?.url,
      item?.location,
      item?.ottPlatform,
      item?.ottServer,
      item?.ottApplication,
      item?.streamRouterId,
      item?.interfaceName,
      item?.routingScope,
      item?.routerOutputArn,
    );
  }

  if (type === "outputProfile" && Array.isArray(item?.outputs)) {
    segments.push(...item.outputs.map((output) => output?.name));
  }

  return segments
    .filter((segment) => segment !== null && segment !== undefined)
    .map((segment) => String(segment).toLowerCase())
    .join(" ");
}

export function matchesPermissionSearch(item, query) {
  if (!query) return true;
  const haystack = String(item?._searchIndex || "").toLowerCase();
  return haystack.includes(String(query).trim().toLowerCase());
}

export function toOption(value, label = value, description = "") {
  return { value, label, description };
}

export function normalizeLocationArray(value) {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== "string") return [];
  return value
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
}
